import cn from 'classnames/bind';
import * as React from 'react';
import { IconSize } from '../../lib/constants.js';
import { Icon as IconMemo } from '../../UIElements/Icon/index.js';
import { InputFooter } from '../InputFooter/index.js';
import { InputHeader } from '../InputHeader/index.js';
import classes from './index.module.scss.js';
import { useControlledState } from '@sbt-web/hooks';

const cx = cn.bind(classes);
const sizeToIconSize = (size) => {
    switch (size) {
        case 'small': {
            return IconSize.SM;
        }
        default: {
            return IconSize.MD;
        }
    }
};
const InputIcon = ({ icon, size }) => {
    return (React.createElement("div", { className: cx('input-icon') },
        React.createElement(IconMemo, { name: icon, iconSize: sizeToIconSize(size) })));
};
const ClearIcon = ({ size, onClick, show, }) => {
    return (React.createElement(IconButton, { iconName: "Close", size: size, onClick: onClick, ariaLabel: "Svuotare il campo", className: cx('clear-icon', { [classes.show]: show }) }));
};
const IconButton = ({ size, iconName, onClick, className, ariaLabel, }) => {
    const iconSize = sizeToIconSize(size);
    return (React.createElement("button", { type: "button", onClick: onClick, "aria-label": ariaLabel, className: className },
        React.createElement(IconMemo, { name: iconName, iconSize: iconSize })));
};
const TextField = React.forwardRef((props, ref) => {
    const { name, type = 'text', icon, inputHeaderProps, maxLength, errorMessage, infoMessage, errorState = false, value, placeholder, disabled = false, size = 'medium', prefix, classes = [], withClearIcon = false, onInputChange = () => undefined, onFocus = () => undefined, onBlur = () => undefined, onCleared = () => undefined, onKeyDown = () => undefined, disableNativeAC = false, autoCapitalize, autoComplete, inputMode, suffixIcon, onSuffixIconClick, } = props;
    const handleInputChange = (newValue) => {
        if (typeof newValue !== 'undefined') {
            onInputChange?.({
                target: { name, value: newValue },
            });
        }
    };
    const [currentValue, setCurrentValue] = useControlledState(value, '', handleInputChange);
    /**
     * The ID of the optional datalist element.
     * If not used, it will be ignored.
     */
    const dataListId = React.useId();
    const footerMessage = errorMessage || infoMessage;
    return (React.createElement("div", { className: cx('cactus-text-field__wrapper', {
            'is-error': errorMessage || errorState,
            'is-disabled': disabled,
            sm: size == 'small',
            md: size == 'medium',
            lg: size == 'large',
        }, ...classes) },
        React.createElement(InputHeader, { name: name, ...inputHeaderProps, style: errorMessage ? 'red' : 'default' }),
        React.createElement("div", { className: cx('input-wrapper') },
            icon && React.createElement(InputIcon, { icon: icon, size: size }),
            prefix && (React.createElement("span", { className: cx('prefix', `size-${mapSizeTextSize[size]}`) }, prefix)),
            React.createElement("input", { ref: ref, type: type, id: name, name: name, value: currentValue, placeholder: placeholder, disabled: disabled, onChange: (e) => {
                    setCurrentValue(e.target.value);
                }, maxLength: maxLength, className: cx(`size-${mapSizeTextSize[size]}`, 'weight-book'), onFocus: onFocus, onBlur: onBlur, autoComplete: disableNativeAC ? 'off' : autoComplete, onKeyDown: onKeyDown, autoCapitalize: autoCapitalize, inputMode: inputMode, list: props.suggestions !== undefined ? dataListId : undefined }),
            props.suggestions !== undefined ? (React.createElement("datalist", { id: dataListId }, props.suggestions.map((suggestion) => (React.createElement("option", { key: suggestion.value, value: suggestion.value }, suggestion.label))))) : null,
            suffixIcon && !withClearIcon && (React.createElement(IconButton, { size: size, iconName: suffixIcon, onClick: onSuffixIconClick, className: cx('suffix-icon', {
                    interactive: !!onSuffixIconClick,
                }), ariaLabel: "suffix icon" })),
            withClearIcon && (React.createElement(ClearIcon, { size: size, onClick: () => {
                    setCurrentValue('');
                    onCleared();
                }, show: !!currentValue && !disabled }))),
        footerMessage && (React.createElement(InputFooter, { message: footerMessage, isError: !!errorMessage }))));
});
const mapSizeTextSize = {
    small: 'small',
    medium: 'small',
    large: 'normal',
};
TextField.displayName = 'TextField';

export { TextField };
//# sourceMappingURL=index.js.map
